"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");

var ActionsHelper = require("../actions/ActionsHelper")

var InputHelper = require("../shared/InputHelper");

var ProjectActions = require("./ProjectActions");
var ProjectConstants = require("./ProjectConstants");
var ProjectStore = require("./ProjectStore");

class SubaccountGiftArray extends React.Component {
	constructor(props) {
		super(props);

		var project = props.project || {};
		var projectSubaccounts = [];
		var subaccounts = [];
		var subaccountAmounts = {};
		var wizardSubaccounts = { subaccountDefaultDescriptions: [] };
		var subaccount;

		project = JSON.parse(JSON.stringify(project)); // clone the project to avoid reference

		// If we are on the client side
		if (typeof (window) !== "undefined") {
			var projectStoreState = ProjectStore.getState();
			subaccountAmounts = projectStoreState.subaccountAmounts || {};
			wizardSubaccounts = projectStoreState.wizardSubaccounts;
		}

		projectSubaccounts = project.subaccounts || [];
		if (!projectSubaccounts.length && project.displayObject && project.displayObject.value && project.displayObject.value.Subaccounts && project.displayObject.value.Subaccounts.length) {
			projectSubaccounts = project.displayObject.value.Subaccounts;
		}

		if (props.isDesignMode) {
			projectSubaccounts = [
				{ "Value":"SUB1", "DefaultDescription":"Subaccount 1", "Description":"Subaccount 1" },
				{ "Value":"SUB2", "DefaultDescription":"Subaccount 2", "Description":"Subaccount 2" },
				{ "Value":"SUB3", "DefaultDescription":"Subaccount 3", "Description":"Subaccount 3" }
			];
		}

		for (var i = 0; i < projectSubaccounts.length; i++) {
			subaccount = projectSubaccounts[i];
			if (subaccount.Description) {
				subaccount.description = subaccount.Description;
			}
			else {
				// Subaccount Override description was not provided, use wizard description (if available)
				var wizardSubaccountIndex = wizardSubaccounts.subaccountDefaultDescriptions.indexOf(subaccount.Value);
				if (wizardSubaccountIndex === -1) {
					// Subaccount Override description and wizard were not provided, use default from Y23
					subaccount.description = subaccount.DefaultDescription
				}
				else {
					subaccount.description = wizardSubaccounts[`${subaccount.Value}_Description`];
				}
			}
			subaccounts.push(subaccount);
		}

		this.state = {
			project,
			subaccounts,
			subaccountAmounts,
			subaccountEditing: {}
		};

		this._onChange = this._onChange.bind(this);
	}

	handleSubaccountAmountChanged(subaccount, event) {
		if (InputHelper.isAmountValid(event.currentTarget.value)) {
			ProjectActions.setSubaccountAmount(subaccount.Value, ActionsHelper.convertFormattedAmountToNumberString(event.currentTarget.value));
		}
	}

	handleSubaccountAmountEdit(subaccount, editing) {
		this.state.subaccountEditing[subaccount.Value] = editing;
		this.setState({ subaccountEditing: this.state.subaccountEditing });
	}

	_onChange() {
		this.setState(ProjectStore.getState());
	}

	componentDidMount() {
		var upsell = this.state.upsell;

		if (ProjectStore.get("upsell") !== upsell) {
			ProjectActions.setUpsell(upsell);
		}

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		ProjectStore.addChangeListener(this._onChange);

		var $context = $(ReactDOM.findDOMNode(this)).closest("[data-component$='GiftAmount']");

		if (typeof ($) !== "undefined") {
			var shouldSubaccountsBeShown = false;
			if (!VisibilityStore.hasRule("subaccount")) {
				VisibilityStore.addRule({
					identifier: "subaccount",
					triggers: [],
					show: (action) => false,
					elements: ($context) => $context.find("[data-component='SubaccountGiftArray'],[data-show-when='subaccount']"),
					initialize: () => {
						return (this.state.subaccounts.length > 0);
					}
				}, $context);
			}
			if (!VisibilityStore.hasRule("giftArray")) {
				VisibilityStore.addRule({
					identifier: "giftArray",
					triggers: [ProjectConstants.GIFT_ARRAY_LOADED],
					shouldTrigger: (action) => {
						return true
					},
					show: () => this.getShouldShowGiftArray($context),
					elements: ($context) => $context.find("[data-react-component-name='ButtonGiftArray'],[data-react-component-name='RadioGiftArray'],[data-react-component-name='SelectGiftArray'],[data-show-when='giftArray']"),
					initialize: () => this.getShouldShowGiftArray($context),
				}, $context);
			}
			if (!VisibilityStore.hasRule("subaccountGiftArray")) {
				VisibilityStore.addRule({
					identifier: "subaccountGiftArray",
					triggers: [],
					show: (action) => false,
					elements: ($context) => $context.find("[data-show-when='both']"),
					initialize: ($context) => {
						shouldSubaccountsBeShown = this.determineIfSubaccountsShouldBeShown($context);
						return shouldSubaccountsBeShown;
					}
				}, $context);
			}

			if (shouldSubaccountsBeShown) {
				//If there are no cached values, making sure the gift array does not have a value selected.
				var cachedValues = ProjectActions.getCachedValues() || {};
				var selectedAmount = cachedValues.amount || "";
				ProjectActions.setGiftAmount(selectedAmount);
			}
		}
	}

	getShouldShowGiftArray($context) {
		// If the gift array will not be hidden, we don't need to hide
		var filter = "[data-react-component-name='ButtonGiftArray']:has([data-hide='subaccounts'])," +
		"[data-react-component-name='RadioGiftArray']:has([data-hide='subaccounts'])," +
		"[data-react-component-name='SelectGiftArray']:has([data-hide='subaccounts'])";
		var show = (this.state.subaccounts.length <= 0 || $context.find(filter).length < 1);
		if (!show) {
			//Because we are hiding the gift array project detail page, we want to clear the amount so we are not charged.
			//	We don't need to consider and pass in tangibleCode and context because we can only have the subaccountGiftArray on the main project detail page and not in category or searchResults.
			ProjectActions.setGiftAmount(0);
		}
		return show;
	}

	getSubaccountAmount(subaccountValue) {
		var editingSubaccount = this.state.subaccountEditing[subaccountValue];
		var subaccountAmount = this.state.subaccountAmounts[subaccountValue];

		if (editingSubaccount && subaccountAmount !== "" && subaccountAmount !== "0" && subaccountAmount !== ".00") {
			return ActionsHelper.replaceAmountDecimalSymbols(subaccountAmount);
		}
		else if (!editingSubaccount && subaccountAmount != null && subaccountAmount !== "" && subaccountAmount !== "0" && subaccountAmount !== ".0" && subaccountAmount !== ".00") {
			return ActionsHelper.formatAmount(subaccountAmount, true, true, true);
		}

		return "";
	}

	determineIfSubaccountsShouldBeShown($context) {
		var show1 = (this.state.subaccounts.length > 0);

		var filter = "[data-react-component-name='ButtonGiftArray']:has([data-hide='subaccounts'])," +
			"[data-react-component-name='RadioGiftArray']:has([data-hide='subaccounts'])," +
			"[data-react-component-name='SelectGiftArray']:has([data-hide='subaccounts'])";
		var show2 = (this.state.subaccounts.length <= 0 || $context.find(filter).length < 1);

		return show1 && show2;
	}

	componentWillUnmount() {
		VisibilityStore.removeRule("subaccount");
		VisibilityStore.removeRule("giftArray");
		VisibilityStore.removeRule("subaccountGiftArray");
		ProjectStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this);
		}
	}

	render() {
		var subaccounts = this.state.subaccounts;

		var emptyPlaceholder = this.props.isDesignMode ? <div className="collapsedComponentPlaceholder">Subaccount Gift Array</div> : null;

		if (!this.props.isDesignMode && (!subaccounts || subaccounts.length <= 0)) {
			return null;
		}

		return (
			<div
				className="subaccount-gift-array"
				data-react-component-name="SubaccountGiftArray"
				data-react-component-category="ProjectComponents"
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				{subaccounts && subaccounts.length > 0 ?
					subaccounts.map((subaccount, index) => {
						return (
							<div
								className={classNames(["subaccount", "row", "form-group", this.props.childClass])}
								data-override-classes={this.props.childClass}
								key={subaccount.Value}
								data-component="SubaccountGiftArray.subaccount"
							>
								<label
									htmlFor={`subaccount-${index}`}
									data-component="SubaccountGiftArray.subaccount.label"
									className={`col-${this.props.horizontalBreakpoint}-2`}
								>
									{subaccount.description}
								</label>
								<div
									className={`col-${this.props.horizontalBreakpoint}-10`}
									data-component="SubaccountGiftArray.subaccount.input"
								>
									<input
										id={`subaccount-${index}`}
										className="form-control"
										type="text"
										value={this.getSubaccountAmount(subaccount.Value)}
										onChange={this.handleSubaccountAmountChanged.bind(this, subaccount)}
										onFocus={this.handleSubaccountAmountEdit.bind(this, subaccount, true)}
										onBlur={this.handleSubaccountAmountEdit.bind(this, subaccount, false)}
										readOnly={this.props.isDesignMode}
										inputMode="decimal"
									/>
								</div>
							</div>
						);
					})
					:
					emptyPlaceholder
				}
			</div>
		);
	}
}

SubaccountGiftArray.defaultProps = {
	theme: "0",
	isCustomTheme: false,
	horizontalBreakpoint: "sm"
};

SubaccountGiftArray.propTypes = {
	isDesignMode: PropTypes.bool,
	project: PropTypes.object,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	horizontalBreakpoint: PropTypes.string
};

module.exports = SubaccountGiftArray;
